<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Acknowledgments</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 1.17em;">I WANT</span> to give a special thank-you to Dreamspinner in general, for accepting the challenge of helping me to bring this story into its own.</p>
<p class="P_Normal">Thanks to the editors and other readers who helped to breathe new life into it and guided me in creating strong and hopefully likeable and authentic characters.</p>
<p class="P_Normal">Thanks to Dreamspinner’s art department for their flexibility, understanding, patience, and talent. I’ve got a new and wonderful cover to go with the revitalized story that is closer to my vision than I could ever have hoped.</p>
<p class="P_Normal">Love you all!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?77815392